export default __webpack_public_path__ + "static/media/7.ad543a0e.jpg";